import React, { useEffect, useState, useRef } from 'react';
import { Alert, Grid, Button, Paper, Typography, CircularProgress, Stack, CssBaseline, Divider, TextField } from '@mui/material/';
import AssistantIcon from '@mui/icons-material/Assistant';

//components imports
import AlertInfo from '../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../components/elements/AlertInfoDialog';
import TopBar from '../../components/nav/TopBar';
import DisplayJson from './components/DisplayJsonComponent';

const TestForm = (): JSX.Element => {

    //set up browser title
    const pageTitle = 'Extranet - TEST: Form Processing';
    document.title = pageTitle;

    const applicationName = 'TEST: Form Processing';

    //set up state
    const [formUrl, setFormUrl] = useState('https://ocpf2.blob.core.windows.net/pdf/intake/53bfde20-2c78-46ab-9be3-c69be0b72c4c.pdf');
    const [formData, setFormData] = useState<any>();
    const [isFormProcessed, setIsFormProcessed] = useState<boolean>(false);
    const [loadPdf, setLoadPdf] = useState<boolean>(false);
    const [loadingError, setLoadingError] = useState<boolean>(false);

    // a timer to show how long it would take to load the form data
    const [timer, setTimer] = useState<number>(0);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    
    // Start timer when loading begins, stop when loading ends
    useEffect(() => {
        setTimer(0);
        if (!isFormProcessed && loadPdf) {
            timerRef.current = setInterval(() => {
                setTimer(prev => prev + 1);
            }, 1000);
        }
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [loadPdf, loadingError, isFormProcessed]);

    useEffect(() => {
        if (isFormProcessed && timerRef.current) {
            clearInterval(timerRef.current);
        }
    }, [isFormProcessed]);

    //need to get the processed form json data from endpoint
    const retrieveFormData = async () => {
        setLoadPdf(true);
        setLoadingError(false);
        ///Audit/GetBankList
        await fetch(`/LLMFormProcessor/GetFormData?pdfUri=${formUrl}`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetFormData',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                    setLoadingError(true);
                }
                else {
                    const data = result.result;
                    setFormData(data);
                    setIsFormProcessed(true);
                    setLoadingError(false);
                    console.log('formData:', data);
                }
            }
            )
    }

    const updateFormUrl = (url: string) => {
        setFormUrl(url);
        setIsFormProcessed(false);
        setLoadPdf(false);
    }

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <>
            <Grid container sx={{ display: 'flex' }}>
                <CssBaseline />
                <TopBar applicationName={applicationName}></TopBar>
            </Grid>
            <Grid item xs={12} marginBottom={1}>
                <Divider />
            </Grid>
            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', marginTop: '15px', marginBottom: '15px' }} >
                <Grid item xs={10} display="flex" justifyContent="center">
                    <Stack direction="row" spacing={1}>
                        <TextField
                            margin="normal"
                            label="Please put the form link here"
                            size="small"
                            value={formUrl}
                            sx={{ minWidth: '600px'}}
                            onChange={(e)=>updateFormUrl(e.target.value)}
                        />
                        <Button size="small" variant="outlined" onClick={retrieveFormData}>Process Form</Button>
                    </Stack>
                </Grid>
                {
                    //show AI progress
                    !isFormProcessed && formUrl && loadPdf && !loadingError &&
                    <Grid item xs={12} display="flex" justifyContent="center">
                        <Alert severity="warning" icon={false}>
                            <Stack direction="row" spacing={1}>
                                <CircularProgress size={18} />
                                <Typography variant="body1">
                                    OCPF AI Assistant is working hard to process the following form:
                                    <span style={{ marginLeft: 8 }}>
                                        {timer}s
                                    </span>
                                </Typography>
                            </Stack>
                        </Alert>
                    </Grid>
                }
                {
                    //display Json
                    isFormProcessed && formData && formUrl &&
                    <>
                        <Grid item xs={12} display="flex" justifyContent="center">
                            <Alert severity="success" icon={<AssistantIcon fontSize="inherit" />} >The form has been successfully processed by the OCPF AI assistant. Please review the information below carefully.</Alert>
                        </Grid>
                        <Grid item xs={5.5} height={1}>
                            <Grid item xs={12}>
                                <DisplayJson formData={formData}></DisplayJson>
                            </Grid>
                        </Grid>
                    </>
                }
                {
                    formUrl && loadPdf &&
                    <Grid item xs={5}>
                        <Paper sx={{ p: 3 }}>
                            <Grid item xs={12}>
                                {
                                    formUrl &&
                                    <iframe src={formUrl} width="100%" height="750px" />
                                }
                            </Grid>
                        </Paper>
                    </Grid>
                }
               
            </Grid> 
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    )
}

export default TestForm;